import React, { useEffect, useState } from "react";
import "./all css/bookcounsilling.css";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/footer";
import "../pages/all css/contactuspagemain.css";
import InterestedSectionMain from "../components/interested section/InterestedSectionMain";
const location = require("../assets/loc-1.png");
const call = require("../assets/loc-2.png");
const mail = require("../assets/loc-3.png");

const allLocalDetails = [
  {
    locationHeadinglocal: "Delhi Registered Office",
    addressFullLocal: `Dynamic House, KH-71,
        Sector 8B, Dwarka,
        New Delhi-110077`,
    emailLocal: `
        info@dynamicwec.net`,
  },
  {
    locationHeadinglocal: "Mumbai",
    addressFullLocal: `915 Topiwala Center,
        Goregaon, Mumbai,
        Maharashtra - 400062`,
    emailLocal: `
        info@dynamicwec.net`,
  },

  {
    locationHeadinglocal: "Chennai",
    addressFullLocal: `B-19/A, Thiru-vi-ka,
        Industrial Estate,
        Guindy, Chennai,
        Tamil Nadu - 600032`,
    emailLocal: `
        info@dynamicwec.net`,
  },
  {
    locationHeadinglocal: "Kochi",
    addressFullLocal: `41 /1865 J,
        Chittoor Rd, Simla Garden,
        Kacheripady Junction, North Kaloor,
        Kacheripady, Ernakulam, Kochi,
        India - 682018`,
    emailLocal: `
        info@dynamicwec.net`,
  },
  
];

const allGlobalDetails = [
  {
    locationHeadinglocal: "Nepal",
    addressFullLocal: `PO Box: 2012, Tokha-7,
    Basundhara Chauki, Dhapasi,
    Kathmandu, Nepal`,
    emailLocal: `
            info@dynamicwec.net`,
  },
  {
    locationHeadinglocal: "United Kingdom",
    addressFullLocal: `91-93, Church St, London,
    NW8 8EU`,
    emailLocal: `
            info@dynamicwec.net`,
  },
 
];

function ContactUsPage(props) {
  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="contactuspage" />
      </div>

      <div className="visa_counselling_main_container">
        <div className="visa_counselling_under_main_container">
          <div className="visa_counselling_hero_section_img_text_container">
            <p className="title_of_video_counselling_text">
              HAVE SOME <br /> QUESTIONS ?
            </p>
            <p className="extra_text_of_video_counselling">
              Book for students who are interested in quality overseas education
              and has a combined leadership experien
            </p>
          </div>
        </div>
      </div>

      <div className="counselloer_bg">
        <div className="visa_counselling_body_section">
          <div className="title_sub_title_Of_body_section">
            <p
              className="title_text wow pulse"
              data-wow-delay="500ms"
              data-wow-iteration="infinite"
              data-wow-duration="1s"
            >
              CORPORATE OFFICE
            </p>
            <p></p>
          </div>

          <div className="map_location_container">
            <div className="map_location_container_left">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7381.153468159732!2d73.165245!3d22.331842!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x56d5b316674bda0f!2sDynamic%20World%20Education%20Community!5e0!3m2!1sen!2sin!4v1650806133219!5m2!1sen!2sin"
                className="video_frame_contact_us"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="places_container">
              <div className="icon_place_name_container">
                <div className="icon_container">
                  <img
                    src={location}
                    className="icon_style_self"
                    alt="location"
                  />
                </div>
                <p className="icon_details">
                  A- 3/5, BIDC, Gorwa Vadodara, Gujarat 390016
                </p>
              </div>
              <div className="icon_place_name_container">
                <div className="icon_container">
                  <img src={call} className="icon_style_self" alt="call" />
                </div>
                <a href="tel: 1800-1020-700" className="icon_details">
                  1800-1020-700
                </a>
              </div>
              <div className="icon_place_name_container">
                <div className="icon_container">
                  <img src={mail} className="icon_style_self" alt="mail" />
                </div>
                <a href="mailto:info@dynamicwec.net" className="icon_details">
                  info@dynamicwec.net
                </a>
              </div>
            </div>
          </div>

          <div className="map_location_container">
            <p className="local_office_text">LOCAL OFFICE</p>
            {allLocalDetails.map((perlocalItem) => {
              return (
                <div className="places_container1" key={Math.random()}>
                  <p className="location_title_text">
                    {perlocalItem.locationHeadinglocal}
                  </p>
                  <div className="icon_place_name_container">
                    <div className="icon_text_container">
                      <p className="icon_details">
                        &#10036; {perlocalItem.addressFullLocal}
                      </p>
                    </div>
                  </div>

                  <div className="icon_place_name_container">
                    <div className="icon_text_container">
                      <a
                        href="mailto:info@dynamicwec.net"
                        className="icon_details"
                      >
                        &#10036; {perlocalItem.emailLocal}
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="map_location_container">
            <p className="local_office_text">GLOBAL OFFICE</p>
            {allGlobalDetails.map((perGlobalItem) => {
              return (
                <div className="places_container1" key={Math.random()}>
                  <p className="location_title_text">
                    {perGlobalItem.locationHeadinglocal}
                  </p>
                  <div className="icon_place_name_container">
                    <div className="icon_text_container">
                      <p className="icon_details">
                        &#10036; {perGlobalItem.addressFullLocal}
                      </p>
                    </div>
                  </div>

                  <div className="icon_place_name_container">
                    <div className="icon_text_container">
                      <a
                        href="mailto:info@dynamicwec.net"
                        className="icon_details"
                      >
                        &#10036; {perGlobalItem.emailLocal}
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <InterestedSectionMain />
      <Footer />
    </>
  );
}

export default ContactUsPage;
